import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorktypesService } from './logic/worktypes.service';
import { WorktypesLogicService } from './logic/worktypes/worktypes-logic.service';
import { WorktypesDaoService } from './dao/worktypes-dao.service';
import { WorktypesStorageDaoService } from './dao/worktypes-dao/worktypes-storage-dao.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: WorktypesService, useClass: WorktypesLogicService },
    { provide: WorktypesDaoService, useClass: WorktypesStorageDaoService }
  ]
})
export class WorktypesModule {}
